import { render, staticRenderFns } from "./registrationDetails.vue?vue&type=template&id=60921e5b&scoped=true"
import script from "./registrationDetails.vue?vue&type=script&lang=js"
export * from "./registrationDetails.vue?vue&type=script&lang=js"
import style0 from "./registrationDetails.vue?vue&type=style&index=0&id=60921e5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60921e5b",
  null
  
)

export default component.exports